export enum SelectedMergeSourceEnum {
  Cepik1 = 'cepik1',
  Cepik2 = 'cepik2',
  Form = 'form',
}
